import { render } from "./Roadmap.vue?vue&type=template&id=a0643ffc&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"

import "./Roadmap.vue?vue&type=style&index=0&id=a0643ffc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0643ffc"]])

export default __exports__